import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PageBanner from './components/PageBanner';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Career from "./pages/Career";
import Contact from "./pages/Contact";
import Services from "./pages/Service";
import Gallery from "./pages/Gallery";

function App() {
    return (
        <Router>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<><PageBanner /><About /></>} />
                <Route path="/service" element={<><PageBanner /><Services /></>} />
                <Route path="/gallery" element={<><PageBanner /><Gallery /></>} />
                <Route path="/career" element={<><PageBanner /><Career /></>} />
                <Route path="/contact" element={<><PageBanner /><Contact /></>} />
                
            </Routes>
            <Footer />
        </Router>
    );
}



export default App;
